import { z } from "zod";

// Schema for a single rotation in the beeps.json file
export const RotationSchema = z.object({
  name: z.string(),
  members: z.array(z.string()),
  frequency: z.enum(["daily", "weekly"]),
  startDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
});

// Schema for the entire beeps.json file
export const BeepsConfigurationSchema = z.object({
  routingPrompt: z.string().optional(),
  rotations: z.array(RotationSchema),
});

// Type for the beeps.json file
export type BeepsConfiguration = z.infer<typeof BeepsConfigurationSchema>;

// Helper to validate the configuration
export function validateBeepsConfiguration(
  config: unknown,
): BeepsConfiguration {
  return BeepsConfigurationSchema.parse(config);
}
